module.exports = __webpack_public_path__ + "img/jribeiro.83016c91.png";